import { Signer } from './signer';
import { Keccak256Hasher } from '../hashers';
import { Platform } from '../providers';
// import {
//   ecsign,
//   bufferToHex,
//   toBuffer,
//   setLengthLeft,
//   hashPersonalMessage,
// } from 'ethereumjs-util';
// const a = '2A77A5C9DBA59D6F8B7A';
// const b = '2737A8A6D8E511CDC9439';
// const c = 'C97E919959D02502F8BCB50';
// function sendSync({ params }) {
//   const msg = hashPersonalMessage(toBuffer(params[0]))
//     .toString('hex')
//     .replace('0x', '');
//   const { r, s, v } = ecsign(
//     new Buffer(msg, 'hex'),
//     new Buffer(`${a}${b}${c}`, 'hex')
//   );
//   const hexsig = bufferToHex(
//     Buffer.concat([
//       setLengthLeft(r, 32),
//       setLengthLeft(s, 32),
//       toBuffer(v - 27),
//     ])
//   );
//   return hexsig;
// }
export class EthSigner extends Signer {
    constructor(from) {
        super(new Keccak256Hasher());
        this.from = from;
        this.currentPlatform = Platform.eth;
    }
    signMessages(messages) {
        return new Promise((resolve, reject) => {
            /*
            try {
              const sig = sendSync({ params: [messages[0].message] });
              resolve([sig]);
            } catch (e) {
              reject(e);
            }
            */
            const from = this.from;
            const params = [messages[0].message, from];
            const method = 'personal_sign';
            window.web3.currentProvider.sendAsync({ method, params, from }, (err, result) => {
                if (err) {
                    reject(err);
                }
                if (result.error) {
                    reject(result.error);
                }
                result = result.result;
                let v = Number.parseInt(result.slice(-2), 16);
                if (v >= 27)
                    v -= 27;
                result =
                    '0x' +
                        this.currentPlatform.toString(16).padStart(2, '0') +
                        result.slice(2, -2) +
                        v.toString(16).padStart(2, '0');
                resolve([result]);
            });
        });
    }
}
//# sourceMappingURL=data:application/json;base64,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